import React from "react";
import {Box, Button, Column, Columns, Title} from "@allxsmith/bestax-bulma";
import useInput from "../../../hooks/useInput";
import usePostQuickLink from "../../../hooks/usePostQuickLink";

function QuickLink() {
  let [quickLinkTitle, titleInput] = useInput({
    type: "text",
    label: "Link Title"
  });
  let [quickLinkUrl, urlInput] = useInput({
    type: "text",
    label: "URL"
  });

  const [, postQuickLink] = usePostQuickLink({
    title: quickLinkTitle,
    url: quickLinkUrl
  });

  const handleSubmit = () => {
    postQuickLink();
  };

  return (
    <Box className="settings_type">
        <details>
            <summary><Title>Add Quick Link</Title></summary>
      <Columns isMultiline>
        {titleInput}
        {urlInput}
      </Columns>
      <Columns isMultiline>
        <Column>
          <Button onClick={handleSubmit} color={"success"} isFullWidth>
            Add
          </Button>
        </Column>
      </Columns>
      </details>
    </Box>
  );
}

export default QuickLink;
